import { el, VNode } from "@dhx/ts-common/dom";
import { ItemType, IItem } from "../types";

export function getCount(item, widgetClass, isLimited) {
	const countColor = {
		danger: " dhx_navbar-count--color_danger",
		secondary: " dhx_navbar-count--color_secondary",
		primary: " dhx_navbar-count--color_primary",
		success: " dhx_navbar-count--color_success",
	}[item.countColor] || " dhx_navbar-count--color_danger";
	return el(".dhx_navbar-count", {
		class: widgetClass + countColor + (!isLimited && parseInt(item.count, 10) > 99 ? " dhx_navbar-count--overlimit" : ""),
	}, isLimited && parseInt(item.count, 10) > 99 ? "99+" : item.count);
}

export function getIcon(iconName = "", type) {
	if (iconName.slice(0, 3) === "dxi") {
		iconName = "dxi " + iconName;
	}
	return el("span", {
		class: `dhx_${type}__icon ${iconName}`
	});
}

export function navbarComponentMixin(widgetName: string, item: IItem, asMenuItem: boolean, body: VNode): VNode {
	const itemClass = getNavbarItemClass(widgetName, item, asMenuItem);
	const hasRibbonSize = widgetName === "ribbon" && (item.type === ItemType.navItem || item.type === ItemType.imageButton);
	return el("li", {
		"_key": item.id,
		"class": itemClass +
			(item.icon && !item.value && hasRibbonSize ? " dhx_ribbon__item--icon" : "") +
			(item.src && !item.value && hasRibbonSize ? " dhx_ribbon__item--icon" : "") +
			(item.size && hasRibbonSize ? " dhx_ribbon__item--" + item.size : ""),
		".innerHTML": item.type === ItemType.customHTML ? item.html : undefined,
		"dhx_id": item.type === ItemType.customHTML ? item.id : undefined,
	}, item.type !== ItemType.customHTML ? [body] : undefined);
}

export function getNavbarButtonCSS({color, size, view, full, icon, circle, loading, value, active}, widgetName) {
	const colorsCss = {
		danger: " dhx_button--color_danger",
		secondary: " dhx_button--color_secondary",
		primary: " dhx_button--color_primary",
		success: " dhx_button--color_success",
	}[color] || " dhx_button--color_primary";
	const sizeCss = {
		small: " dhx_button--size_small",
		medium: " dhx_button--size_medium",
	}[size] || " dhx_button--size_medium";
	const viewCss = {
		flat: " dhx_button--view_flat",
		link: " dhx_button--view_link",
	}[view] || " dhx_button--view_flat";
	const fullCss = full ? " dhx_button--width_full" : "";
	const circleCss = circle ? " dhx_button--circle" : "";
	const loadingCss = loading ? " dhx_button--loading" : "";
	const iconViewCss = icon && !value ? " dhx_button--icon" : "";
	const activeCss = active ? " dhx_button--active" : "";
	return colorsCss + sizeCss + viewCss + fullCss + circleCss + loadingCss + activeCss + iconViewCss;
}

const getNavbarItemClass = (widgetName: string, item: IItem, asMenuItem: boolean) => {
	let baseClassName = "";
	let resultClassName = "";
	if (asMenuItem) {
		baseClassName = "dhx_menu-item";
	} else {
		baseClassName = "dhx_" + widgetName + "__item";
	}
	resultClassName = baseClassName + (item.css ? " " + item.css : "");

	if (item.type === ItemType.spacer || item.type === ItemType.separator) {
		resultClassName += ` ${baseClassName}--${item.type}`;
	}

	if (item.type === "button" && widgetName === "sidebar" && !item.icon) {
		resultClassName += " dhx_navbar-item--colapse_hidden";
	}
	return resultClassName;
};